import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Button } from './Button';
import { Icon } from './Icon';

export type RecommendedCartProductTileBasicInfoProps = b2x.RecommendedCartProductTileBasicInfoProps;

export const RecommendedCartProductTileBasicInfo = ({
  onToggleShowMore,
  priceHelper,
  product,
  showMore,
  sku,
}: RecommendedCartProductTileBasicInfoProps) => {
  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <b2x.Row>
      <b2x.Col size={''}>
        <b2x.Row gap={3}>
          <b2x.Col size={'auto'}>
            <b2x.ImageSwitcher
              alt={product.name}
              aspectRatio={b2x.appConfig.productImageAspectRatio}
              fluid
              src={product.image?.src}
            />
          </b2x.Col>
          <b2x.Col size={''}>
            <b2x.H6
              className={classnames({ small: b2x.untilBreakpoint('sm', currentBreakpoint) }, 'fw-bold mb-0')}
              marginBottom={2}
            >
              <strong>{product.name}</strong>
            </b2x.H6>
            {sku && (
              <b2x.P className="small" margin={0}>
                {sku.name}
              </b2x.P>
            )}
          </b2x.Col>
          <b2x.Col display={{ md: 'flex', xs: 'none' }} justifyContent={'end'} size={{ md: 4, xl: 3, xs: 12 }}>
            <b2x.PriceBlock hiddenDiscountPercentage priceHelper={priceHelper} />
          </b2x.Col>
        </b2x.Row>
      </b2x.Col>
      <b2x.Col size={'auto'}>
        <b2x.Div textAlign={'end'}>
          <Button className="px-2" onClick={onToggleShowMore} type="button" variant="primary">
            <Icon name="cart" size={25} />
          </Button>
        </b2x.Div>
      </b2x.Col>
      {!showMore && (
        <b2x.Col display={{ md: 'none', xs: 'flex' }} justifyContent={'end'} size={12}>
          <b2x.PriceBlock hiddenDiscountPercentage priceHelper={priceHelper} />
        </b2x.Col>
      )}
    </b2x.Row>
  );
};
